import Eu from '@di-shared/features/history/date/HistoryDateCalendar/.eu';
import Kr from '@di-shared/features/history/date/HistoryDateCalendar/.kr';
import Na from '@di-shared/features/history/date/HistoryDateCalendar/.na';
import Environment from '@di-shared/features/environment/Environment';
import {Dispatch, SetStateAction} from 'react';

export interface HistoryDateCalendarProps {
  vin: string;
  selectedDate: Date;
  setSelectedDate: Dispatch<SetStateAction<Date>>;
  isMonthMode: boolean;
  isMonthChange: boolean;
  setIsMonthChange: Dispatch<SetStateAction<boolean>>;
}

export default function HistoryDateCalendar({
  vin,
  selectedDate,
  setSelectedDate,
  isMonthMode,
  isMonthChange,
  setIsMonthChange,
}: HistoryDateCalendarProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isMonthMode={isMonthMode}
          isMonthChange={isMonthChange}
          setIsMonthChange={setIsMonthChange}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isMonthMode={isMonthMode}
          isMonthChange={isMonthChange}
          setIsMonthChange={setIsMonthChange}
        />
      </Environment.Kr>
      <Environment.Na>
        <Na
          vin={vin}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isMonthMode={isMonthMode}
          isMonthChange={isMonthChange}
          setIsMonthChange={setIsMonthChange}
        />
      </Environment.Na>
    </>
  );
}
